import { render, staticRenderFns } from "./OrganizationView.vue?vue&type=template&id=78e403e9&"
import script from "./OrganizationView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationView.vue?vue&type=script&lang=ts&"
import style0 from "#/css/pages/declaration.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports